export default "__VITE_PUBLIC_ASSET__974e6352__"